export default "__VITE_ASSET__BffjSgE5__"